import React, { useEffect, useRef, useState } from 'react';
import {
  DKButton,
  showToast,
  DKLabel,
  TOAST_TYPE,
  INPUT_VIEW_DIRECTION,
  DKInput,
  DKIcon,
  DKIcons,
  showLoader,
  removeLoader
} from 'deskera-ui-library';

import CustomInput from '../CustomInput/CustomInput';
import {

  fetchContactCustomNumberFormat,
  selectContactCustomNumbersFormats,
} from '../../Redux/Slices/CustomNumberFormat';

import { useDispatch, useSelector } from "react-redux";

import {
  CUSTOM_NUMBER_INPUT_MODULES,
  NUMBER_REGEX_PATTERN,
  // INPUT_VIEW_DIRECTION,
  POPUP_CALLBACKS_TYPE,
  PRODUCTS_CAPS,
  BtnType,
  CallBackPayloadType,
  ReactSelectOptionsType,
  UpdateCallBacksRefType
} from '../../components/SequenceNumberFormat/Other';
import { POPUP_CLICK_TYPE, POPUP_TYPE } from '../../constants/Enums';
import PopupWrapper, { PopupClickActionType } from '../../SharedComponents/PopupWrapper';

import CustomNumberFormat from './CustomNumberFormat';
import CustomDropdowList from './CustomDropdowList';
import CustomNumberFormatService from '../../services/CustomNumberFormat';
import { useTranslation } from 'react-i18next';
import Utility from '../../utility/Utility';
import useDebounce from '../../Hooks/useDebounce';
import Popup from '../../components/common/Popup';
import { DELETE_SEQ_FORMAT, EMPLOYEE_ID_EXIST } from '../../constants/Constant';
import i18next from 'i18next';
import { isMobileWebView } from '../../utility/ViewportSizeUtils';

function CustomNumberFormatInput(props: any) {
  /**
   * Custom Number Format
   */
  const dispatch = useDispatch();
  const compactInputRef = useRef<any>(null);

  const refInitialState: UpdateCallBacksRefType = {
    pushDataToParent: { type: POPUP_CALLBACKS_TYPE.NONE },
    storeCallbacksRef: { updateContact: 'click' }
  };

  const sequenceFormatRef = useRef<UpdateCallBacksRefType>(refInitialState);

  const contactCustomNumberList: any = useSelector(
    selectContactCustomNumbersFormats
  );

  const [showCustomNumberDropdownList, setShowCustomNumberDropdownList] =
    useState<boolean>(false);

  const showCustomNumberDropdown = () => {
    setShowCustomNumberDropdownList((value) => !value);
  };

  const [showCustomNumberPopup, setShowCustomNumberPopup] =
    useState<boolean>(false);

  const [manualModeActive, setManualModeActive] = useState(false);
  const [manualEntry, setManualEntry] = useState<string>('');
  const debouncedManualEntry = useDebounce(manualEntry, 1000);

  const initialCustomNumberFormatState = [] as any;

  const [customNumberFormatList, setCustomNumberFormatList] = useState(
    initialCustomNumberFormatState
  );

  const [sequenceCode, setSequenceCode] = useState('');
  const [sequenceObj, setSequenceCodeObj] = useState({});
  const [customFormatNumberData, setCustomFormatNumberData] = useState('');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    renderUpdatedCustomNumberFormat();
  });

  // useEffect(() => {
  //   if (props.openList) {
  //     setShowCustomNumberDropdownList(true);
  //   }

  //   if (
  //     !Utility.isEmpty(props.autoNumberingFormat) &&
  //     props.module === CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE
  //   ) {
  //     if (props.autoNumberingFormat.manualMode) {
  //       setManualModeActive(true);
  //       setSequenceCode(props.autoNumberingFormat.text);
  //       setManualEntry(props.autoNumberingFormat.text);
  //     }
  //   }
  // }, [props]);

  useEffect(() => {
    const checkCodeExists = async () => {
      if (!Utility.isEmpty(debouncedManualEntry)) {
        let seqNum = debouncedManualEntry;
        try {
            try {
                seqNum = debouncedManualEntry.replace(/\s/g, '').trim();
            } catch { }
        } catch { }
        showLoader(i18next.t("VERIFY_EMPID"));
        const codeExists = await CustomNumberFormatService.checkNumberFormatExistance(seqNum, props.module);
        removeLoader();
        if (codeExists?.status === 200) {
          setSequenceCode(debouncedManualEntry);
          setSequenceCodeObj(null);
          let data = {};
          if (
            props.module === CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE &&
            !Utility.isEmpty(props.autoNumberingFormat)
          ) {
            data = {
              text: debouncedManualEntry,
              id: null,
              manualMode: props.autoNumberingFormat.manualMode
            };
          } else {
            data = {
              text: debouncedManualEntry,
              id: null,
              manualMode:manualModeActive
            };
          }
          if(props.employeeIdValid) {
            props.employeeIdValid(true)
          }
          props.selectedFormat(data);
        } else if (codeExists?.status === 409) {
          if(props.employeeIdValid) {
            props.employeeIdValid(false)
          }
          if(codeExists?.message && codeExists?.message?.toLowerCase() === EMPLOYEE_ID_EXIST) {
            showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.WARNING);
          } else {
            showToast(codeExists?.message, TOAST_TYPE.WARNING);
          }
        }
      } else {
        resetSequenceCode();
        if(props.employeeIdValid) {
          props.employeeIdValid(true)
        }
        
      }
    };

    checkCodeExists();
  }, [debouncedManualEntry]);

  const resetSequenceCode = () => {
    if (
      props.module === CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE &&
      !Utility.isEmpty(props.autoNumberingFormat?.id)
    ) {
      const defaultFormatIndex = customNumberFormatList.findIndex(
        (format: any) => format.id === props.autoNumberingFormat.id
      );
      const defaultFormat = customNumberFormatList[defaultFormatIndex];
      if (!Utility.isEmpty(defaultFormat)) {
        setSequenceCode(defaultFormat.sequenceCode);
        setSequenceCodeObj(defaultFormat)
        sendSelectedFormat(defaultFormatIndex, defaultFormat.sequenceCode);
      }
    } else {
      if (!Utility.isEmpty(customNumberFormatList)) {
        const defaultFormatIndex = customNumberFormatList.findIndex(
          (format: any) => format.isDefault
        );
        const defaultFormat = customNumberFormatList[defaultFormatIndex];
        if (!Utility.isEmpty(defaultFormat)) {
          setSequenceCode(defaultFormat.sequenceCode);
          setSequenceCodeObj(defaultFormat)
          sendSelectedFormat(defaultFormatIndex, defaultFormat.sequenceCode);
        }
      }
    }
    if(props.employeeIdValid) {
      props.employeeIdValid(true)
    }
  };

  useEffect(() => {
    resetSequenceCode();
  }, [customNumberFormatList]);


  const customNumberpopupBtnConfig: BtnType[] = [
    {
      title: t(`CUSTOM_NUMBER_FORMAT.BUTTON.CANCEL`),
      class: 'border-m mr-s',
      clickAction: POPUP_CLICK_TYPE.CLOSE_POPUP
    },
    {
      title: t(`CUSTOM_NUMBER_FORMAT.BUTTON.SAVE`),
      class: 'bg-app text-white mr-s',
      clickAction: POPUP_CLICK_TYPE.SAVE_CUSTOM_DOCUMENT_NUMBER
    }
  ];

  const onSequenceCodeClick = (index: any, value: any) => {
    setSequenceCode(value);
    setSequenceCodeObj(null)
    setShowCustomNumberDropdownList(false);
    sendSelectedFormat(index, value);
  };

  const onSequenceCodeEdit = (index: any, value: any) => {
    setShowCustomNumberPopup(true);
    setCustomFormatNumberData(value);
  };

  const onSequenceCodeDelete = (index: any, value: any) => {
    if (value) {
      let payload = { sequenceId: value.id };
      CustomNumberFormatService.deleteCustomFormatNumber(payload).then(
        (response: any) => {
          if (response && response.status === 409) {
            if(response?.message  && response?.message?.toLowerCase() === DELETE_SEQ_FORMAT) {
              showToast(i18next.t("DELETE_SEQ_FORMAT"), TOAST_TYPE.WARNING);
            } else {
              showToast(response.message, TOAST_TYPE.WARNING);
            }
          }

          if (response && response.status === 200) {
            showToast('Deleted Successfully', TOAST_TYPE.SUCCESS);
            fetchUpdatedCustomNumberFormat();
          }
        },
        (err) => {
          console.error('Error while custom number format: ', err);
        }
      );
    }
  };

  const sendSelectedFormat = (index: any, value: any) => {
    let text = value.toString();
    let id: any = '',
      data: any = {};

    switch (props.module) {
      case CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE:
        id = contactCustomNumberList[index].id;
        break;
    }

    if (
      props.module === CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE &&
      props.autoNumberingFormat?.manualMode
    ) {
      data = { ...props.autoNumberingFormat };
    } else {
      if (!Utility.isEmpty(props.autoNumberingFormat)) {
        data = {
          text,
          id,
          manualMode: props.autoNumberingFormat.manualMode
            ? props.autoNumberingFormat.manualMode
            : false
        };
      } else {
        data = {
          text,
          id
        };
      }
    }
    props.selectedFormat(data);
  };

  const catchClicks = (data: PopupClickActionType) => {
    switch (data.type) {
      case POPUP_CLICK_TYPE.CLOSE_POPUP:
        setShowCustomNumberPopup(false);
        setCustomFormatNumberData('');
        break;
      case POPUP_CLICK_TYPE.SAVE_CUSTOM_DOCUMENT_NUMBER:
        sequenceFormatRef.current?.storeCallbacksRef.createSequenceFormat();
        break;
    }
  };

  const parentChildInteraction = (passingData: CallBackPayloadType) => {
    switch (passingData.type) {
      case POPUP_CALLBACKS_TYPE.SAVE_CUSTOM_NUMBER:
        sequenceFormatRef.current.storeCallbacksRef.createSequenceFormat =
          passingData.data;
        break;
      case POPUP_CALLBACKS_TYPE.CLOSE_POPUP:
        fetchUpdatedCustomNumberFormat();
        setShowCustomNumberPopup(false);
        setCustomFormatNumberData('');
        break;
    }
  };

  const fetchUpdatedCustomNumberFormat = () => {
    switch (props.module) {
      case CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE:
        dispatch(fetchContactCustomNumberFormat());
        break;
    }
  };

  const renderUpdatedCustomNumberFormat = () => {
    switch (props.module) {
      case CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE:
        setCustomNumberFormatList(contactCustomNumberList);
        break;
    }
  };

  const onMouseUp = (e: any) => {
    const target = e.target;
    const editingContainer = target.closest('#custom-number-list');

    if (!editingContainer) {
      setShowCustomNumberDropdownList(false);
    }
  };
  const savePopup = () => {
    sequenceFormatRef.current?.storeCallbacksRef.createSequenceFormat()
  }

  useEffect(() => {
    fetchUpdatedCustomNumberFormat()
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  useEffect(() => {
    if (compactInputRef) {
      compactInputRef.current?.focus();
    }
  }, [manualModeActive]);

  /**
   * Custom Number Format
   */

  return (
    <div
      className={
        props.showCompact ? '' : 'position-relative parent-width column ml-l mb-r'
      }
    >
      {props.showCompact && (
        <div className="position-relative custom-number-compact-input">
          {!manualModeActive && (
            <DKButton
              className={'parent-width compact-custom-no-input '}
              style={{
                borderRadius: 4,
                padding: 4
              }}
              title={sequenceCode ? sequenceCode : 'Select'}
              onClick={() => showCustomNumberDropdown()}
            />
          )}
          {manualModeActive && (
            <>
              <input
                name="custom-input-box"
                ref={compactInputRef}
                type="text"
                className={`w-full h-full text-right p-2 listPickerBG rounded border border-transparent hover:border-gray-300`}
                style={{
                  borderRadius: 4,
                  padding: 4
                }}
                disabled={!manualModeActive}
                value={manualEntry}
                onChange={(e: any) =>{ setManualEntry(e.target.value) }}
              />
              <div
                className={`position-absolute left-1.5 cursor-pointer opacity-0 disable-input-mode`}
                style={{ top: 7 }}
                title="Disable manual input"
                onClick={() => {
                  setManualModeActive(false);
                  resetSequenceCode();
                }}
              >
                <DKIcon src={DKIcons.ic_close} className="ic-s" />
              </div>
            </>
          )}
        </div>
      )}
      {!props.showCompact && (
        <div
          className={
            'position-relative parent-width justify-content-between ' +
            (props.isRow ? 'row' : 'column')
          }
        >
          <div className={'mt-1 parent-width position-relative'}
           style={{width:'390px', display:'flex'}}>
            <DKInput
              title={props.hideLabel ? '' : i18next.t("EMPLOYEE_ID")}
              direction={
                props.isRow
                  ? INPUT_VIEW_DIRECTION.HORIZONTAL
                  : INPUT_VIEW_DIRECTION.VERTICAL
              }
              value={manualEntry}
              required={false}
              placeholder={ (manualModeActive) ? (''):(sequenceCode ? sequenceCode :i18next.t("EMPLOYEE_ID")) }
              readOnly={!manualModeActive}
              onClick={() =>
                manualModeActive ? '' : showCustomNumberDropdown()
              }
              onChange={(value: string) => {
                if (!Utility.isEmpty(value)) {
                  
                  setManualEntry(value);
                  // setManualEntryTrimString(value)
                } else {
                  const data = {
                    ...props.autoNumberingFormat,
                    text: ''
                  };
                  props.selectedFormat(data);
                  setManualEntry('');
                  // setManualEntryTrimString('')
                }
              }}
            />
            {manualModeActive && (
              <div
                className={`position-absolute cursor-pointer opacity-60`}
                style={{top:"32px" , right:"5px"}}
                title="Disable manual mode"
                onClick={() => {
                  setManualEntry('');
                  // setManualEntryTrimString('')
                  const data = {
                    ...props.autoNumberingFormat,
                    sequenceObj: sequenceObj,
                    manualMode: false
                  };
                  
                  props.selectedFormat(data);
                  setManualModeActive(false);
                  showCustomNumberDropdown();
                }}
              >
                <DKIcon src={DKIcons.ic_close} className="ic-s" />
              </div>
            )}
          </div>
        </div>
      )}
      {showCustomNumberDropdownList && (
        <div
          id="custom-number-list"
          className={`custom-number-list w-72 position-absolute -my-4 flex-1 z-10 ${props.extraClass}`}
          style={{width:'390px', zIndex:1000,top:'60px'}}
        >
          <CustomDropdowList
            className="shadow-l"
            data={customNumberFormatList}
            needIcon={false}
            createNewButton={{
              title: `+ Custom Number Format`,
              className: 'text-blue fw-b ml-xs',
              onClick: () => {
                setShowCustomNumberPopup(true);
              }
            }}
            manualInputButton={{
              title: `Manual input`,
              className: 'text-blue fw-b ml-xs',
              onClick: () => {
                setShowCustomNumberPopup(false);
                showCustomNumberDropdown();
                // Note : Will use in future
                // if(props.employeeIdValid) {
                //   props.employeeIdValid(false)
                // }
                setManualModeActive(true);
                const data = {
                  ...props.autoNumberingFormat,
                  text: '',
                  manualMode: true
                };
                props.selectedFormat(data);
              }
            }}
            onSelect={(index: number, value: any) => {
              onSequenceCodeClick(index, value);
            }}
            onEdit={(index: number, value: any) => {
              onSequenceCodeEdit(index, value);
            }}
            onDelete={(index: number, value: any) => {
              onSequenceCodeDelete(index, value);
            }}
          />
        </div>
      )}
      {showCustomNumberPopup && (
        <Popup
          popupClass = {`popup-overflow ${!isMobileWebView()?"sequence-number-popup ":""}`}
        >
          <div className="row justify-content-between">
          <DKLabel className="fw-m fs-l" text="Custom Document Numbering Format" />
          <div className="d-flex">
            <DKButton title="Save" className="bg-app  text-white"  onClick={()=>{savePopup()}} />
            <DKButton title="Cancel" className=" border-m bg-gray1  ml-m" onClick={()=>{setShowCustomNumberPopup(false)
                                                                                    setCustomFormatNumberData('')}}/>
          </div>
        </div>
          {console.log("inside")}
          <CustomNumberFormat
            data={customFormatNumberData}
            passingInteraction={(callback: CallBackPayloadType) => {
              parentChildInteraction(callback);
            }}
            documentType={props.module}
          />
      </Popup>
      )}
    </div>
  );
}

export default CustomNumberFormatInput;
